import { createContext } from "react";

export const SpeakerContext = createContext(null)